module.exports = __webpack_public_path__ + "static/cube19-21fa2fffd5d3fe9a187bba85ccccfd26.svg";